import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'shared/hooks/useTranslation';

const LanguageSelector = () => {
    const { currentLanguage, changeLanguage, t } = useTranslation();

    const handleLanguageChange = (event: SelectChangeEvent) => {
        changeLanguage(event.target.value);
    };

    return (
        <FormControl size="small" sx={{ minWidth: 80, maxWidth: 120 }}>
            <InputLabel id="language-select-label">{t('common.language')}</InputLabel>
            <Select
                labelId="language-select-label"
                value={currentLanguage}
                label={t('common.language')}
                onChange={handleLanguageChange}
                MenuProps={{
                    disableScrollLock: true
                }}
            >
                <MenuItem value="es">Español</MenuItem>
                <MenuItem value="en">English</MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
